export const RoadmapList4 = [
    {
        text: 'Pursuit of Traditional real world finance partnerships'
    },
    {
        text: 'More to Come'
    },
];